import { useLogoutMutation } from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"
import { clearSession } from "src/utils/session"

export const useOnLogout = () => {
    const [logout] = useLogoutMutation()
    const { hotel_id } = useProfile()

    const onLogout = () => {
        const sesion_id = sessionStorage.getItem("@sesion_id") || ""
        logout({
            variables: {
                hotel_id,
                cerrar_turno: false,
                sesion_id,
            },
        })
            .finally(() => {
                clearSession()
                window.location.href = "/"
            })
    }

    return {
        onLogout,
    }
}
